import request from '@/utils/http.js';
import { wechatShare } from "./brand/wechat.js";

/**
 * 初始化获取邀请卡信息
 * （1）WAP观看端设计的邀请卡模板选择更换，返回全量数据
 * （2）PC观看端邀请卡只有二维码分享，仅返回invite_code值
 * @param {*} data
 * @param {*} options
 * @returns
 */
const createInvite = (data = {}) => {
  // const url = '/v3/interacts/invite-card/watch-get-info'; 废弃 2023/02/28
  const url = '/v1/marketing/app/invite/card/init-invite-card';
  return request({
    url,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

/**
 * B打开A的邀请卡直播时，创建B与A的邀请关系记录
 * @param {*} data
 * @returns
 */
const bindInvite = (data = {}) => {
  // const v3 = '/v3/interacts/invite-card/create-invite-othor-relation' 废弃 2023/02/28
  const v3 = '/v1/marketing/app/invite/card/create-invite-other-relation'
  const url = v3;
  return request({
    url,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

const createInviteItem = (data = {}, options = {}) => {
  const url = '/v3/interacts/invite-card/create-invite-self-relation';
  return request({
    url,
    method: 'POST',
    data,
    headers: Object.assign({
      'Content-Type': 'application/json'
    }, options.headers)
  });
};

// const wechatShare = (data = {}) => {
//   const url = '/v3/commons/auth/weixin-share';
//   return request({
//     url,
//     method: 'POST',
//     data
//   });
// };
const getInviteDetailsUrl = (data = {}) => {
  const url = '/v1/marketing/app/invite/stat/my-invite-details-url';
  return request({
    url,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

/**
 * 获取邀请卡，用于初始获取邀请码（高性能接口)
 * @param {*} data 请求参数
 * @returns
 */
const getMyInviteCard = (data = {}) => {
  const url = '/v1/marketing/app/invite/card/my-invite-card';
  return request({
    url,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export default {
  createInvite,
  createInviteItem,
  wechatShare,
  bindInvite,
  getInviteDetailsUrl,
  getMyInviteCard
};
